export const CHANNEL_ID_PAID_SEARCH = 'chnl_paid_search';
